// extracted by mini-css-extract-plugin
module.exports = {"pg-speech-box":"eo","pgSpeechBox":"eo","speech-list-box":"ep","speechListBox":"ep"};